module.exports = new __parcel__URL__("inter_planetary_image.363b142e.png").toString();